// inviteAnalytics — 「友達を招待」ダイアログの利用回数計装 (room-invite-2026-10-01.md)。
//
// `analytics.invite { action }` を fire-and-forget で送る。server は
// `analytics_events` に `event_type = 'share.invite'` + `phase = action` で記録する。
// `timelapseShareAnalytics` / `layoutSwitchAnalytics` と同じく Transport port のみに依存し、
// 送信失敗は握りつぶす (計装が招待 UX を邪魔しない)。

import type { InviteAction } from '@oekaki/protocol';
import type { Transport } from './ports/Transport.js';

export const reportInvite = (transport: Transport, action: InviteAction): void => {
  // socket が open でなければ server が部屋を特定できないので黙って捨てる。
  if (transport.status.t !== 'open') return;
  try {
    transport.send({ t: 'analytics.invite', action });
  } catch {
    // best-effort
  }
};
